import { InjectionToken, type Signal } from '@angular/core';

/**
 * Plugs an app's "home page" behaviour into the generic side-nav without the UI
 * layer depending on app code. Absent adapter → the menu shows no home indicator.
 */
export interface HomePageMenuAdapter {
  /** Route path of the current home menu item, or null if none. */
  readonly currentHomePath: Signal<string | null>;

  /** Open the UI that lets the user pick their home page. */
  openSelector(): void;
}

export const HOME_PAGE_MENU_ADAPTER = new InjectionToken<HomePageMenuAdapter>(
  'HOME_PAGE_MENU_ADAPTER',
);
